module.exports = __webpack_public_path__ + "static/media/Virtual-mirror-lens-4-psd_Fresh-GRAYZEL.0afd3fe8.png";